import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {httpOptions} from '../../../configurations/configuration';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs/Observable';
import { Speaker } from '../../../models/speaker/speaker-list';

@Injectable({
  providedIn: 'root'
})
export class SpeakerListService {
  speakerListUrl: string;
  speakerAvailabilityListUrl:string;

  constructor(private http: HttpClient) {
    this.speakerListUrl = environment.baseURI + environment.apiUrl + 'speaker/list';
    this.speakerAvailabilityListUrl = environment.baseURI + environment.apiUrl + 'speaker/getAllSpeakerByAvailability';
  }

  getAllSpeaker(filterObj): Observable<Speaker> {
    
    return this.http.get<Speaker>(this.speakerListUrl + "?filter=" + encodeURIComponent(JSON.stringify(filterObj)));
  }

  getAllSpeakerByAvailability(filterObj) {
    return this.http.get<any>(this.speakerAvailabilityListUrl + "?filter=" + encodeURIComponent(JSON.stringify(filterObj)), httpOptions);
  }

}
